module.exports = __webpack_public_path__ + "img/logo.9ec1e524.png";